import React from "react";
import { Link } from "react-router-dom";

export function HeaderSpecialLink(props: {
	icon: string;
	title: string;
	to: string;
	isInApp?: boolean;
}) {
	return (
		<HeaderSpecialLinkWrapper
			to={props.to}
			isInApp={props?.isInApp}
			title={props.title}
		>
			<>
				<i
					className={`header__links__icon u-icon u-icon--${props.icon}`}
				/>
				<span className="header__links__label">{props.title}</span>
			</>
		</HeaderSpecialLinkWrapper>
	);
}

function HeaderSpecialLinkWrapper(props: {
	to: string;
	isInApp?: boolean;
	children: JSX.Element;
	title?: string;
}) {
	//handle router or usual redirection
	if (props.isInApp) {
		return (
			<Link
				to={props.to}
				title={props.title}
				className="header__links__item u-anchor u-anchor--secondary"
			>
				{props.children}
			</Link>
		);
	}
	return (
		<a
			href={props.to}
			title={props.title}
			target="_blank"
			className="header__links__item u-anchor u-anchor--secondary"
		>
			{props.children}
		</a>
	);
}
